import { Avatar, Box, Typography } from '@mui/material'
import { getPlatform } from '../../../../utilities/orientationAndPlatform'

export default function Contact({...params}){

    let contact = params.contact
    let toggleModal = params.toggleModal
    let setInput = params.setInput
    let setIsNewContact = params.setIsNewContact

    let platform = getPlatform()
    let justify = ''
    if (platform === 'desktop') justify = 'center'

    const handleClick = () => {
        setIsNewContact(false)
        setInput({...contact})
        toggleModal()
    }

    function nameToColor(name) {
        let hash = 0;
        let i;

        /* eslint-disable no-bitwise */
        for (i = 0; i < name.length; i += 1) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */

        return color;
    }

    const getInitials = (name) => {
        if (!name) return "";
        return name
            .split(" ")
            .map((word) => word[0])
            .join("")
            .toUpperCase()
    };

    return (
        <>
            <Box className={"nameEmailAvatarBox"} display={"flex"} flexDirection={"row"} alignItems={"center"} justifyContent={justify} gap={"10px"} paddingBottom={'10px'} onClick={handleClick}>
                <Avatar sx={{ width: 40, height: 40, bgcolor: nameToColor(contact.name), color: "#FFFFFF" }}>{getInitials(contact.name)}</Avatar>
                <Box className="nameEmailBox" display="flex" flexDirection="column">
                    <Typography fontSize="18px">{contact.name}</Typography>
                    <Typography fontSize="18px">{contact.email}</Typography>
                </Box>
            </Box>
        </>
    )
}
